import { usePage } from "@inertiajs/react"
import CommunitiesLayout from "./Layout"
import ConversationApp from "../../communities/pages/messages/ConversationView"

const Conversation = (props) => {
  const { id } = usePage().props
  return <ConversationApp conversationId={id} />
}
Conversation.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>
export default Conversation
